import ActionCardComponent from './ActionCardComponent';

export default ActionCardComponent;
